/**
 * Validation of the FmFormFlowPage running summary, split from
 * `FmFormFlowPage.validation.ts` so that file stays under the 500-line gate.
 */
import { validateValue } from './FmFormFlowField.validation';
import {
  exactFormFlowKeys as exact,
  failFormFlow as fail,
  formFlowArray as array,
  formFlowObject as object,
  formFlowText as text,
  uniqueFormFlowIds as uniqueIds,
} from './FmFormFlowValidation.shared';

/** A titled, non-empty list of the owner's answers so far. */
export function validateSummary(value: unknown): void {
  const summary = object(value, 'descriptor.summary');
  exact(summary, new Set(['title', 'values']), 'descriptor.summary');
  text(summary.title, 'descriptor.summary.title');
  const values = array(summary.values, 'descriptor.summary.values');
  if (!values.length) fail('descriptor.summary.values', 'must name at least one answer');
  uniqueIds(values, 'descriptor.summary.values');
  values.forEach((item, index) => validateValue(item, `descriptor.summary.values[${index}]`));
}
